/**
 * The geocoding service options
 */
class GeocodingOptions {

   constructor(options, reverseGecoding = false) {
      var config = (reverseGecoding) ? reachMap.geocodingOptions.reverse : reachMap.geocodingOptions.geocode;
      /*
       * The place name for forward geocoding
       */
      this.query = options.query;
      /*
       * The place latitude coordinate
       */
      this.latitude = options.latitude;
      /*
       * The place longitude coordinate
       */
      this.longitude = options.longitude;
      /*
       * Defines the results to a bounding box.
       */
      this.mapbounds = options.mapbounds || config.mapBounds;
      /*
       * Controls whether to include results outside of supplied map bounds.
       */
      this.limitbybounds = options.limitbybounds || config.limitbybounds;
      /*
       * Defines the number of results returned.
       */
      this.limit = options.limit || config.limitResults;
      /*
       * Limit results to one or more countries separated by commas (ca=Canada, ca=France etc...)
       */
      this.country = options.country || config.country;
      /*
       * Defines the language to use for response text.
       */
      this.language = options.language || config.language;
      /*
       * Used to Filter results to include only a subset of the available feature types.
       * Options can be: country, district, place, address ... Multiple options can be comma-separated.
       * See mapbox documentation for more details:
       * https://www.mapbox.com/api-documentation/?language=cURL#retrieve-places-near-a-location
       */
      this.types = options.types || config.types;
   }
   /**
    * Get the geocoding options
    * @return {object} - The geocoding options.
    */
   getGeocodeOptions() {
      return ({
         query: this.query,
         country: this.country,
         mapbounds: this.mapbounds,
         limitbybounds: this.limitbybounds,
         limit: this.limit,
         language: this.language
      });
   }
   /**
    * Get the reverse geocoding options
    * @return {object} - The reverse geocoding options.
    */
   getReverseOptions() {
      return ({
         latitude: this.latitude,
         longitude: this.longitude,
         country: this.country,
         language: this.language,
         limit: this.limit,
         types: this.types
      });
   }
}

export default GeocodingOptions;
